
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore, uiStore } from "@/store/store";
import defensiveCopy from "@/util/defensive-copy";
import { ElementPreset } from "@/types/presets";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";

// @ts-ignore
import draggable from "vuedraggable";
import { openUiPanel } from "@/lib/panels/panels";
import RepeaterItemAccordion from "@/components/Reusable/CustomInputs/Repeater/RepeaterItemAccordion.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    RepeaterItemAccordion,
    draggable,
    TextInput,
    Icon
  }
})
export default class PresetsList extends Vue {
  @Prop()
  searchable: boolean | undefined;

  @Prop()
  presets!: ElementPreset[];

  dragOptions = {
    animation: 200,
    handle: ".breakdance-repeater-item-handler",
    filter: ".breakdance-repeater-item--ignore-drag",
    ghostClass: "breakdance-repeater-item--ghost",
    forceFallback: true
  };

  get presetsByElement() {
    const presetsByElement: Record<string, ElementPreset[]> = {};

    this.filteredPresets.forEach(preset => {
      if (!presetsByElement[preset.availableForType]) {
        presetsByElement[preset.availableForType] = [];
      }
      presetsByElement[preset.availableForType].push(preset);
    });

    // Sort presets by name
    Object.keys(presetsByElement).forEach(key => {
      presetsByElement[key].sort((a, b) => {
        if (a.name < b.name) return -1;
        if (b.name < a.name) return 1;
        return 0;
      });
    });

    return presetsByElement;
  }

  get filteredPresets() {
    if (this.searchString) {
      const lowerCaseSearchString = this.searchString?.toLowerCase() ?? "";
      return this.presets.filter(preset =>
        preset.name.toLowerCase().includes(lowerCaseSearchString)
      );
    }

    return this.presets;
  }
  searchString: string | null = "";

  deletePreset(preset: ElementPreset) {
    const i = this.presets.findIndex(p => p.id === preset.id);
    const newPresets = defensiveCopy(this.presets);
    newPresets.splice(i, 1);
    this.$emit("input", newPresets);
  }

  handleDrag(newPresets: ElementPreset[]) {
    this.$emit("input", defensiveCopy(newPresets));
  }

  editPreset(preset: ElementPreset) {
    uiStore.setActivePresetId(preset.id);
    openUiPanel("presets");
  }

  getElementName(element: string) {
    return configStore.element(element).name;
  }
}
